export const SET_KNOWN_HOSTS = 'SET_KNOWN_HOSTS';
export const SET_USER_USERNAME = 'SET_USER_USERNAME';
export const SET_USER_INFO_1 = 'SET_USER_INFO_1';
export const SET_USER_INFO_2 = 'SET_USER_INFO_2';
export const SET_USER_INFO_3 = 'SET_USER_INFO_3';
export const LOGOUT = 'LOGOUT';
export const SET_SERVER_URL = 'SET_SERVER_URL';
export const SET_SERVER_INFO = 'SET_SERVER_INFO';
export const SET_CLIENT_URL = 'SET_CLIENT_URL';
export const SET_ADMIN_CLIENT_CONFIG = 'SET_ADMIN_CLIENT_CONFIG';
export const NOTIFICATION_SEND = 'NOTIFICATION_SEND';
export const NOTIFICATION_SET = 'NOTIFICATION_SET';
export const SET_SERVER_SECRET_EXISTS = 'SET_SERVER_SECRET_EXISTS';
